import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { Address } from 'viem';
import { useChainId } from 'wagmi';
import { tokenKeys } from './token-keys';

export interface Pair {
  address: Address;
  chain_id: number;
  decimal: number;
  name: string;
  token_id: string;
  total_balance: number;
}

export interface Token {
  token: string;
  address: Address;
  decimal: number;
}

export type GetSupportedPairsResponse = Array<Pair>;

export const getSupportedTokens = async (chainId: number, isLP?: boolean) => {
  const { data } = await apiClient.get<GetSupportedPairsResponse>('/v1/tokens/supported-tokens', {
    params: {
      chainId,
      isLP,
    },
  });

  return data;
};

export type UseGetSupportedPairsOptions<TData, TError> = QueryOptions<
  GetSupportedPairsResponse,
  TError,
  TData,
  ReturnType<typeof tokenKeys.networkSupportedTokens>
>;

export const useSupportedTokens = <TData = GetSupportedPairsResponse, TError = Error>(
  number: number,
  isLP?: boolean,
  options?: UseGetSupportedPairsOptions<TData, TError>,
  selectedChain?: number,
) => {
  const chainId = useChainId();

  return useQuery({
    queryKey: tokenKeys.networkSupportedTokens(selectedChain ?? chainId, number, isLP),
    queryFn: () => getSupportedTokens(selectedChain ?? chainId, isLP),
    ...options,
  });
};
